import { Card, CardContent, Typography } from '@mui/material'
import { useList, useNavigation } from '@refinedev/core'

export default function UpcomingRenewals() {
  const { data, isLoading, isError } = useList({
    resource: 'upcoming-renewals',
  })

  const { show } = useNavigation()

  if (isLoading) {
    return <Typography>Loading...</Typography>
  }

  if (isError) {
    return <Typography>Error loading orgs with upcoming renewals</Typography>
  }

  return (
    <>
      <Typography variant="h6" gutterBottom>
        Upcoming renewals
      </Typography>

      {data?.data.map((org) => (
        <Card key={org.uuid} sx={{ my: 1 }}>
          <CardContent>
            <Typography
              variant="body1"
              color="primary"
              sx={{ cursor: 'pointer' }}
              onClick={() => {
                show('orgs', org.uuid)
              }}
            >
              {org.name}
            </Typography>
            <Typography variant="body2">
              Membership renews on{' '}
              {new Date(
                org.membership_until +
                  (org.membership_until.endsWith('Z') ? '' : 'Z')
              ).toLocaleString('en-NZ', {
                timeZone: 'Pacific/Auckland',
                day: '2-digit',
                month: 'short',
                year: 'numeric',
              })}
            </Typography>
            {org.last_login_date ? (
              <Typography variant="body2" color="textSecondary">
                Last Login:{' '}
                {new Date(
                  org.last_login_date +
                    (org.last_login_date.endsWith('Z') ? '' : 'Z')
                ).toLocaleString('en-NZ', {
                  timeZone: 'Pacific/Auckland',
                  day: '2-digit',
                  month: 'short',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: true,
                })}{' '}
                - {org.last_login_user_name}
              </Typography>
            ) : (
              <Typography variant="body2" color="textSecondary">
                Last Login: - Unknown please check org activity page
              </Typography>
            )}
          </CardContent>
        </Card>
      ))}
    </>
  )
}
